import { create } from 'zustand';

interface SplashState {
  /** Active splash reasons keyed by stable id (e.g. persist, token, bootstrap). */
  blockers: Record<string, true>;
  /** Adds or removes a splash blocker without tearing down the overlay between phases. */
  setBlocker: (id: string, active: boolean) => void;
}

/**
 * Shared splash visibility. Multiple bootstrap gates register blockers; the overlay
 * stays mounted as long as any blocker is active so entrance animation runs once.
 */
export const useSplashStore = create<SplashState>((set) => ({
  blockers: {},
  setBlocker: (id, active) =>
    set((state) => {
      if (active) {
        if (state.blockers[id]) {
          return state;
        }
        return { blockers: { ...state.blockers, [id]: true } };
      }
      if (!state.blockers[id]) {
        return state;
      }
      const next = { ...state.blockers };
      delete next[id];
      return { blockers: next };
    }),
}));
